








import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class PageStatusLabel extends Vue {
  @Prop({type: Number, required: true}) isAllPage: number;

  get color() {
    switch (this.isAllPage) {
      case 1:
        return 'blue';
    }
  }
}
